import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withAuth0 } from "@auth0/auth0-react";
import { Button } from "@material-ui/core";

class Recipe extends Component{
    
    componentWillUnmount() {
         if(this.refs.shipping.checked)
              this.props.substractShipping()
    }

    handleChecked = (e)=>{
        if(e.target.checked){
            this.props.addShipping();
        }
        else{
            this.props.substractShipping();
        }
    }

    render(){
  
        return(
            <div className="container">
                <div className="collection">
                    <li className="collection-item">
                            <label>
                                <input type="checkbox" ref="shipping" onChange= {this.handleChecked} />
                                <span> Shipping(+366$)</span>
                            </label>
                        </li>
                        <li className="collection-item"><b>Total: {this.props.total} $</b></li>
                    </div>
                    <Button>Checkout</Button>
                 </div>
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        addedItems: state.shoppingSparePartsReducer.addedItems,
        total: state.shoppingSparePartsReducer.total
    }
}

const mapDispatchToProps = (dispatch)=>{
    return{
        addShipping: ()=>{dispatch({type: 'ADD_SHIPPING'})},
        substractShipping: ()=>{dispatch({type: 'SUB_SHIPPING'})}
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withAuth0(Recipe))
